import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FloatingCartComponent } from './floating-cart.component';

import { FloatingCartPriceComponent } from './floating-cart-price/floating-cart-price.component';
import { FloatingCartProceedButtonComponent } from './floating-cart-proceed-button/floating-cart-proceed-button.component';
import { FloatingCartProductComponent } from './floating-cart-product-list/floating-cart-product/floating-cart-product.component';
import { FloatingCartProductListComponent } from './floating-cart-product-list/floating-cart-product-list.component';
import { SharedModule } from '@app/shared/shared.module';
import { ImagesModule } from '@app/shared/components/images/images.module';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, ImagesModule],
  declarations: [
    FloatingCartComponent,
    FloatingCartPriceComponent,
    FloatingCartProceedButtonComponent,
    FloatingCartProductComponent,
    FloatingCartProductListComponent
  ],
  exports: [
    FloatingCartComponent,
    FloatingCartPriceComponent,
    FloatingCartProceedButtonComponent,
    FloatingCartProductComponent,
    FloatingCartProductListComponent
  ],
  providers: []
})
export class FloatingCartModule {}
